export default {
  type: 'guardian_consent',
  content: {
    street: null,
    building_number: '22',
    flat_number: '2233',
    postal_code: '23432',
    city: 'test',
    inquiry_description: 'test',
    inquiry_pride: 'test',
    inquiry_help: 'tes',
    inquiry_difficulty: 'test',
    inquiry_like: 'test',
    future_self: 'test',
    three_words_description: 'test',
    reasons_for_happiness: 'test',
    superpower: 'test',
    world_change: 'test',
    application_reason: 'test',
    dream: 'test'
  },
  status: {
    id: 1,
    value: 'to_accept',
    display_value: 'Do akceptacji',
    color: 'F7CDAA'
  },
  changelogs: [
    {
      action: {
        description: 'Dodanie zgody rodzica / opiekuna'
      },
      created_at: '2022-03-11T13:21:34+01:00'
    }
  ],
  created_at: '2022-03-11T13:21:34+01:00',
  modified_at: '2022-03-11T13:21:34+01:00'
}
